const files = require.context('.', false, /\.js$/)
const modules = {}
files.keys().forEach(filename => {
  if (filename === './index.js') return
  return modules[filename.replace(/(\.\/|\.js)/g, '')] = files(filename).default
})
export default modules
